// extracted by mini-css-extract-plugin
module.exports = {"diversity":"styles_diversity__73PZ3","pulse":"styles_pulse__rPjSB","jump":"styles_jump__A52Uq","wiggle":"styles_wiggle__Hknjm"};